import React from 'react';
import { Dialog, IconButton, Button } from '@mui/material';
import { CloseIcon, DeleteIcon } from '@components/icons/svg-icon.tsx';
import { useTranslation } from 'react-i18next';
import { DeleteDialogProps } from '@shared/models/delete-dialog.model';

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  title,
  description,
  deleteButtonText,
  isLoading,
  onDelete,
  onCancel,
  children
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      slotProps={{
        paper: {
          className: `${
            children ? 'w-[550px]' : 'w-[440px]'
          } max-w-[calc(100%-32px)]! m-4! px-6! pt-6! pb-5! rounded-2xl! shadow-[0_20px_50px_rgba(20,20,40,0.2)]!`
        }
      }}
    >
      <div className="flex items-start gap-3">
        <div className="mt-1 flex items-center justify-center w-11 h-11 rounded-xl bg-(--red-2)/10 shrink-0">
          <DeleteIcon strokeColor="var(--red-2)" className="w-5.5! h-5.5!" />
        </div>

        <div className="flex flex-col gap-1 flex-1 min-w-0 pt-px">
          <h2 className="text-lg font-semibold text-(--dark-2)">{title}</h2>
          <p className="text-sm text-(--gray-2)">
            {description ?? t('delete_popup_description')}
          </p>
        </div>

        <IconButton
          aria-label={t('delete_popup_cancel_button_text')}
          onClick={onCancel}
          className="w-9! h-9! -mt-1.5! -mr-1.5! shrink-0 hover:bg-(--gray-11)!"
        >
          <CloseIcon stroke="var(--gray-2)" className="w-4! h-4!" />
        </IconButton>
      </div>

      {children && <div className="mt-10">{children}</div>}

      <div className="mt-6 grid grid-cols-2 gap-3">
        <Button
          onClick={onCancel}
          variant="outlined"
          className="min-w-0! w-full! max-w-none! h-11! border-(--gray-6)! text-[15px]! hover:opacity-100! hover:bg-(--gray-11)!"
        >
          {t('delete_popup_cancel_button_text')}
        </Button>
        <Button
          loading={isLoading}
          onClick={onDelete}
          variant="contained"
          className="min-w-0! w-full! max-w-none! h-11! text-[15px]! font-semibold!"
        >
          {deleteButtonText ?? t('delete_popup_delete_button_text')}
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
